
import { useState, useCallback, useEffect, } from "react";
import "../styles/layouts/collapsible.scss";


export type CollapsibleProps = {
    notAvailable?: boolean,
    noCollapse?: boolean
    children: any;
    title?: string;
    className?: string;
    titleClasses?: string,
    id?: number,
    openId?: number,
    defaultExpanded?: boolean,
    exclusionAction?: (id: number) => void
}

export default function Collapsible({ defaultExpanded, openId, id, exclusionAction, className, children, title, titleClasses, noCollapse = false }: CollapsibleProps) {

    const [collapsed, setCollapsed] = useState<boolean>(true);
    const toggleCollapsed = useCallback(() => {
        if (noCollapse || !collapsed) return;
        if (collapsed && exclusionAction) {
            exclusionAction(id || -1);
        }
        setCollapsed(!collapsed);
    }, [collapsed, exclusionAction, id, noCollapse])

    useEffect(() => {
        if (openId !== id) {
            setCollapsed(true);
        }
    }, [id, openId])

    useEffect(() => {
        if (openId !== id) {
            setCollapsed(true);
        } else if (openId === id) {
            setCollapsed(false);
        }
    }, [id, openId])

    useEffect(() => {
        setCollapsed(!defaultExpanded)
    }, [defaultExpanded])


    return <div className={`collapsible-container ${className} ${collapsed ? '' : 'collapsible-stretch'}`}>
        <div onClick={toggleCollapsed}
            className={`collapsible-title ${!noCollapse ? `collapsible-clickable` : ``} ${!collapsed ? 'collapsible-open' : ''}`}>
            {title && <div className={titleClasses}>{title}</div>}
            {!noCollapse && <div
                className={`collapsible-arrow ${titleClasses} ${collapsed ? `arrow-down` : `arrow-up`}`}>
            </div>}
        </div>
        {(noCollapse || !collapsed) && <div className="collapsible-content">
            {children}
        </div>}
    </div>

    //${collapsed ? `arrow-right` : `arrow-down`}
}